import React, { Component } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { Table, Input, ListGroup, ListGroupItem } from 'reactstrap';

import { ROUTES, insertIdtoUrl } from 'constants/Routes.js';
import { categoryFilter } from 'utils/categoryfilter.js';

class CategoryList extends Component {

  render() {
    let $categoryList = this.props.categories.map((category) => {
      return (
        <tr key={category.id}>
          <td key={category.id}>
            <NavLink activeClassName="navActive" onClick={this.props.setName.bind(this, category.name)} to={insertIdtoUrl(ROUTES.CATEGORY_REPORTS, category.id)}>
              {category.name}</NavLink>
          </td>
        </tr>
      )
    })
    return (
      <Table hover id="categoryTable" className='styled-box-shadow left-nav-box'>
        <thead>
          <tr>
            <th>Soono Surveys</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>
              <form autoComplete="off">
                <input className="form-control bg-light" type="search" placeholder="Search" id="categoryInput" onChange={categoryFilter} />
              </form>
            </th>
          </tr>
          {$categoryList}
        </tbody>
      </Table>
    );
  }
}

export default CategoryList;



// WEBPACK FOOTER //
// ./src/components/reports/CategoryList.js